import { useParams, useNavigate } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import NewCoproducerForm from "../../components/co-producer/NewCoproducerForm";

export default function NewCoproducer() {
    const { productId } = useParams<{ productId: string }>();
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/products/edit/${productId}?tab=coproduction`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Convidar Co-Produtor"
                description="Criar novo co-produtor para o produto"
            />
            <PageBreadcrumb
                pageTitle="Convidar Co-Produtor"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <NewCoproducerForm
                    productId={productId}
                    onSuccess={() => {
                        // Redirecionar para a página de edição do produto na aba de co-produtor
                        navigate(`/products/edit/${productId}?tab=coproduction`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao criar co-produtor:", error);
                    }}
                />
            </div>
        </>
    );
}